import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const OffsetGrid = styled.div`
  background: ${color.aliceBlue[50]};
`

export const Container = styled.div`
  max-width: 1230px;
  margin: 0 auto;
  padding: 128px 30px 96px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 992px) {
    flex-direction: column;
    max-width: 830px;
    padding: 112px 30px 56px;
  }
  @media (max-width: 768px) {
    max-width: 536px;
    padding: 80px 15px 40px;
  }
`

export const Eyebrow = styled.div`
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  color: ${color.primary[700]};
  margin-bottom: 24px;
  @media (max-width: 576px) {
    font-size: 12px;
    line-height: 18px;
  }
`

export const Heading = styled.div`
  font-weight: 900;
  font-size: 48px;
  line-height: 60px;
  letter-spacing: -0.02em;
  color: ${color.oxfordBlue[900]};
  margin-bottom: 32px;
  @media (max-width: 992px) {
    font-size: 36px;
    line-height: 44px;
  }
  @media (max-width: 768px) {
    font-size: 30px;
    line-height: 38px;
  }
`

export const Body = styled.div`
  font-weight: 350;
  font-size: 16px;
  line-height: 24px;
  color: ${color.copy[700]};
`

export const ContentSide = styled.div`
  max-width: 500px;
  margin-right: 24px;
  a:hover {
    text-decoration: none;
    transition: color 0.15s ease;
  }
  @media (max-width: 992px) {
    max-width: 100%;
    margin-right: 0;
    margin-bottom: 48px;
  }
`

export const JobSide = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 570px;
  @media (max-width: 992px) {
    max-width: 100%;
  }
`

export const JobTitle = styled.div`
  font-weight: 900;
  font-size: 20px;
  line-height: 30px;
  color: ${color.oxfordBlue[900]};
  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 24px;
  }
`

export const JobDepartment = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${color.copy[700]};
  margin: 8px 0;
`

export const JobLocation = styled.div`
  font-weight: 350;
  font-size: 16px;
  line-height: 24px;
  color: ${color.copy[700]};
`

export const JobCard = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px 0 24px 24px;
  border-bottom: 1px solid ${color.oxfordBlue[50]};
  button {
    white-space: nowrap;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 24px;
    button {
      width: 100%;
    }
  }
`

export const JobInfo = styled.div`
  max-width: 358px;
  margin-right: 12px;
  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 24px;
  }
`
